module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC41IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMTAuNSAxNCI+CiAgPHBhdGggaWQ9Im1hcC1tYXJrZXItYWx0LXNvbGlkIiBkPSJNNC43MSwxMy43MThDLjczNyw3Ljk1OCwwLDcuMzY3LDAsNS4yNWE1LjI1LDUuMjUsMCwwLDEsMTAuNSwwYzAsMi4xMTctLjczNywyLjcwOC00LjcxLDguNDY4YS42NTcuNjU3LDAsMCwxLTEuMDc5LDBabS41NC02LjI4QTIuMTg3LDIuMTg3LDAsMSwwLDMuMDYyLDUuMjUsMi4xODcsMi4xODcsMCwwLDAsNS4yNSw3LjQzN1oiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-marker-alt-solid.svg
// module id = akYZ
// module chunks = 4